import { bootInertia } from "../lib/inertia"

bootInertia()
